import React from 'react';
import { useLoadScript } from '@react-google-maps/api'; // Import useLoadScript
import Skeleton from 'react-loading-skeleton';
import SearchBar from '../components/SearchBar';
import Tag from '../components/Tag';

const libraries = ['places']; // Required for autocomplete in SearchBar

const SearchForm = ({ status }) => {
  // Load Google Maps API
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  return (
    <>
      {status === 'loading' ? (
        // Affiche un seul Skeleton pendant le chargement
        <div className="container">
          <Skeleton height={400} />
        </div>
      ) : (
        // Affiche le bloc réel quand le statut n'est pas 'loading'
        <div className="container twyny-container twyny-blue-background">
          <div className="row">
            <div className="col-md-12">
              <h1 className="twyny-h1 bold500">
                Réservez tous <b>vos services pros</b>,<br />
                quand et où vous voulez.
              </h1>
              <div className="twyny-tag">
                <h5>En ligne</h5>
                <span className="twyny-p-separator"></span>
                <h5>À domicile</h5>
                <span className="twyny-p-separator"></span>
                <h5>Chez le professionnel</h5>
                <span className="twyny-p-separator"></span>
                <h5>24h/24</h5>
              </div>
            </div>
            <div className="col-md-10 mx-auto twyny-white-form">
              {/* Pass isLoaded to SearchBar */}
              {isLoaded ? <SearchBar isGoogleLoaded={isLoaded} /> : null}
            </div>
            <div className="col-md-12 twyny-tag-with-icon">
              <Tag icon="card-02.png" name="Prix fixes" styled={'blue'} />
              <Tag icon="users-profiles-check.png" name="Professionnels triés et qualifiés" styled={'blue'} />
              <Tag icon="clock-01.png" name="Prise de rdv en moins de 5min" styled={'blue'} />
              <Tag icon="lock-02.png" name="Paiement 100% sécurisé" styled={'blue'} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SearchForm;